module.exports = __webpack_public_path__ + "b55bc91f370fc6037c56c880a692f5bd.svg";